/*
* Custom JS
* Add custom javascript here!
*/

document.addEventListener('DOMContentLoaded', event => {
});

/**
 * STIGS: Add to Cart through the Ajax cart, then go to the cart page.
 * Same experience for shoppers as before (they land on /cart), but adding in the
 * background lets Shopify report the add-to-cart event to Meta and other pixels.
 * A full-page form post never fires that event.
 * If the background add fails for any reason, the form falls back to the normal post.
 */
(function () {
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (evt.defaultPrevented || form.hasAttribute('data-stigs-native')) return;
    if (!window.fetch || !window.FormData) return;

    evt.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = root + 'cart';
      })
      .catch(function () {
        if (btn) btn.disabled = false;
        form.setAttribute('data-stigs-native', '');
        HTMLFormElement.prototype.submit.call(form);
      });
  });
})();

/** EVENTS
 * Product Form
 * document.addEventListener('product:form:loaded', (event) => {
 *   let variant = event.detail.variant; // Give you the default selected variant
 *   let formElement = event.target;
 *   console.log(variant, formElement)
 * });
 */
